import { Alert } from "@mui/material";
import type { JSX, PropsWithChildren } from "react";
import { cloneElement, useCallback, useEffect, useMemo, useState } from "react";
import { getErrorMessage } from "@entrilia/shared/api/axiosHelper.ts";
import LoaderBox from "@entrilia/shared/components/LoaderBox.tsx";
import { useGroupsContext } from "../../groups/contexts/GroupsContext.ts";

interface Props {
  clientCode: string;
  children: JSX.Element;
}

export default function ReportGroupsConnector({ clientCode, children }: PropsWithChildren<Props>) {
  const { groups: reportGroups, actions } = useGroupsContext();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string>();

  const currentReportGroups = useMemo(() => {
    return reportGroups[clientCode] || [];
  }, [reportGroups, clientCode]);

  const loadReportGroups = useCallback(() => {
    // eslint-disable-next-line @eslint-react/set-state-in-effect
    actions.load(clientCode).catch((err) => setError(getErrorMessage(err)));
  }, [actions, clientCode]);

  useEffect(() => {
    const currentReportGroups = reportGroups[clientCode];
    if (currentReportGroups) {
      // TODO #209
      // eslint-disable-next-line @eslint-react/set-state-in-effect
      setLoading(false);
      return;
    }
    loadReportGroups();
  }, [clientCode, loadReportGroups, reportGroups]);

  if (error) {
    return <Alert severity="error">{error}</Alert>;
  }

  return (
    <LoaderBox overlay loading={loading}>
      {cloneElement(children, { groups: currentReportGroups })}
    </LoaderBox>
  );
}
